import Vue from 'vue'
import Vuex from 'vuex'

import model from './modules/model'
import scenes from './modules/scenes'
import general from './modules/general'
import materialList from './modules/material-list'
import visibilitySingleList from './modules/visibility-single-list'
import visibilityGroupList from './modules/visibility-group-list'
import viewsList from './modules/views-list'
import statesList from './modules/states-list'
import postprocessing from './modules/postprocessing'
import background from './modules/background'
import environment from './modules/environment'
import environmenttexturesList from './modules/environmenttextures-list'
import ui from './modules/ui'
import player from './modules/player'
import liquid from './modules/liquid'

Vue.use(Vuex)

const getters = {}
const state = {}
const actions = {}
const mutations = {}

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  modules: {
    scenes,
    model,
    general,
    postprocessing,
    background,
    environment,
    materialList,
    visibilitySingleList,
    visibilityGroupList,
    viewsList,
    statesList,
    environmenttexturesList,
    ui,
    player,
    liquid
  },
  strict: true
})
